import React from 'react';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ITEM_MATCH_STATUS, RELATION_TYPE, itemMatchLabelKey } from '../documentLifecycle.js';

/** Match chip used by LinkDocumentsModal and the create-page pending-links summary. */
const LinkDocumentMatchChip = ({ candidate, relationType }) => {
    const { t } = useTranslation();
    if (Number(relationType) === RELATION_TYPE.PAYMENT_FOR) {
        return candidate?.isExactMatch
            ? <Chip size="small" color="primary" label={t('LinkDocumentsExactMatch')} />
            : null;
    }
    const status = candidate?.itemMatchStatus ?? ITEM_MATCH_STATUS.UNKNOWN;
    const isAmountMismatch = status === ITEM_MATCH_STATUS.AMOUNT_MISMATCH;
    const color = status === ITEM_MATCH_STATUS.EXACT ? 'primary'
        : status === ITEM_MATCH_STATUS.PARTIAL ? 'warning'
            : status === ITEM_MATCH_STATUS.MISMATCH ? 'error'
                : 'default';
    return (
        <Chip
            size="small"
            color={isAmountMismatch ? undefined : color}
            variant={status === ITEM_MATCH_STATUS.EXACT || isAmountMismatch ? 'filled' : 'outlined'}
            label={t(itemMatchLabelKey(status))}
            sx={isAmountMismatch ? {
                backgroundColor: '#FFF4E5',
                color: '#E65100',
                border: '1px solid #F57C00',
                '& .MuiChip-label': { color: '#E65100' },
            } : undefined}
        />
    );
};

export default LinkDocumentMatchChip;
